import { Injectable } from "@angular/core";
import {
  AcepSSOService,
  GlobalDomOpsService,
  GlobalDataOpsService,
  CommonOperationsService
} from "@acepteam/globalspack";
import { GroupPortalDomService, GroupPortalDataService } from "../../services";
import {
  DomService,
  DataService,
  HelperService,
  LoggerService
} from "../../../core/services";
import { MyAccountDataOpsService } from "../../services/my-account-dataops.service";
import { HttpClient, HttpResponse } from "@angular/common/http";
import {
  ChapterDetails,
  ChapterInfo
} from "../../../shared/models/chapter-details";
import { ProductSubType } from "../../../shared/enums/xrm.constants";
import { OrderGenProduct } from "../../../shared/models";
import { CustomerAddress } from "../../../shared/models/my-account-data.models";
import { getPrimaryAddress } from "../../helpers/mapper";
import { Observable, Observer, Subject, of } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class DashboardService {
  private header = new Subject<any>();
  private orderAmount = new Subject<string>();
  private orderNumber = new Subject<string>();
  constructor(
    private ssoService: AcepSSOService,
    private globalDomOpsService: GlobalDomOpsService,
    private groupPortalDataService: GroupPortalDataService,
    private memberappDomService: GroupPortalDomService,
    private domService: DomService,
    private globalDataOpsService: GlobalDataOpsService,
    private dataService: DataService,
    private myAccountDataService: MyAccountDataOpsService,
    private commonOpsService: CommonOperationsService,
    private helperService: HelperService,
    private loggerService: LoggerService,
    private http: HttpClient
  ) { }

  getHeader(): Observable<any> {
    return this.header.asObservable();
  }

  getOrderAmount(): Observable<any> {
    return this.orderAmount.asObservable();
  }

  getOrderNumber(): Observable<any> {
    return this.orderNumber.asObservable();
  }
}